import { Box, Text } from "@chakra-ui/layout";
import { TempArquivo } from "core/features/arquivo/typings/index";
import Anexos from "ui/components/Anexos";
import ButtonAnexarArquivosTemp from "components/Button/ButtonAnexarArquivosTemp";

function QuestaoArquivo({
  value,
  onChange,
}: {
  value: TempArquivo | null;
  onChange: (arg: TempArquivo[] | null) => any;
}) {
  return (
    <Box>
      <Text fontWeight="500" fontSize={18} mb={4}>
        Arquivo
      </Text>

      {value ? (
        <Anexos
          numColumns={3}
          anexos={[
            {
              id: value.id,
              mimetype: value.mimetype,
              referencia: value.referencia,
              name: value.name || value.nome,
            },
          ]}
          setValue={(anexos) =>
            onChange(anexos?.length ? (anexos as TempArquivo[]) : null)
          }
        />
      ) : null}

      {!value ? (
        <ButtonAnexarArquivosTemp
          multiple={false}
          accept="image/*, application/pdf"
          maxFiles={1}
          maxFileSizeMb={200}
          variant="outline"
          buttonText="Carregar"
          currentFilesLength={0}
          onFinishUploading={(arquivos) => {
            onChange(arquivos ?? null);
          }}
        />
      ) : null}
    </Box>
  );
}

export default QuestaoArquivo;
